import { createStore } from 'vuex';
import axios from 'axios';

// cleaned Ok

// Fonctions utilitaires pour encoder/décoder l'URL
function encodeURL(value) {
  try {
    return btoa(unescape(encodeURIComponent(value)));
  } catch (e) {
    return '';
  }
}

function decodeURL(value) {
  try {
    return decodeURIComponent(escape(atob(value)));
  } catch (e) {
    return '';
  }
}

// Fonction pour analyser les paramètres de l'URL et en faire la configuration par défaut
function parseUrlParams() {
  let params = new URLSearchParams(window.location.search);
  
  // Vérifie si le paramètre 'data' est présent dans l'URL alors on le décode pour récupérer les paramètres de l'URL
  const urlData = params.get('data');
  if (urlData) {
    const urlDataDecoded = decodeURL(urlData);
    const urlDataParams = new URLSearchParams(urlDataDecoded);
    params = urlDataParams;
  }
  
  // Déterminer si on est en mode "start=R"
  
  // Construire l'objet de retour
  const result = {
    //modeAdmin: params.get('modeadmin') === 'mika',

    langue: params.get('langue')?.length === 2 ? params.get('langue') : 'fr',
    filtreType: params.get('f') && /^[^\s]+$/.test(params.get('f')) ? params.get('f') : '',
    playlist: params.get('playlist')?.split(',') || [],
    mode: ['normal', 'list', 'playlist'].includes(params.get('mode')) ? params.get('mode') : 'normal',
    url: window.location.href,
    hideFiche: params.get('start') === 'R',
    session: params.get('start') || '', // <-- AJOUT ICI
  };
  console.log('parseUrlParams', result);

  if (result.filtreType === 'playlist') {
    result.mode = 'playlist';
  }
  const uuidParam = params.get('uuid');
  result.uuid = uuidParam && /^[a-z0-9]{1,10}$/.test(uuidParam) ? uuidParam : 'rag0';
  

  return result;
}

const urlParams = parseUrlParams();

const initialState = {
  storeEcran: null,
  ficheOn: false,
  modeAdmin: false,
  showAll: false,
  storeJobsDatas: null,
  storeModalMessage: 'close',
  storeUrlArray: urlParams,
  hideFiche: urlParams.hideFiche || false,
  triggerModeList: null,
  maVersion: '1.1.0.0', // <-- Version de l'application
  session: urlParams.session, // <-- AJOUT ICI
};

export default createStore({
  state: { ...initialState },

  mutations: {
    setStateValue(state, { key, value }) {
      state[key] = value;

      // Mémoriser l'index de l'uuid courant dans storeUrlArray.id
      if (key === 'storeUrlArray' && value?.uuid && state.storeJobsDatas?.jobs) {
        const job = this.getters.getIndexIdByUuid(value.uuid);
        state.storeUrlArray.id = job ? state.storeJobsDatas.jobs.indexOf(job) : 0;
      }

      // Création de l'URL
      const { storeUrlArray } = state;
      let url = `langue=${storeUrlArray.langue}`;

      if (storeUrlArray.filtreType) {
        url += `&f=${storeUrlArray.filtreType}`;
      }
      //if (storeUrlArray.mode !== 'normal') {
      //  url += `&mode=${storeUrlArray.mode}`;
      //}
      if (storeUrlArray.uuid.length > 1 && storeUrlArray.uuid.length < 10) {
        url += `&uuid=${storeUrlArray.uuid}`;
      }
      // deboublonner les UUIDs dans la playlist
      if (storeUrlArray.playlist && Array.isArray(storeUrlArray.playlist)) {
        storeUrlArray.playlist = [...new Set(storeUrlArray.playlist)];
      }
      if (storeUrlArray.playlist.length > 0) {
        url += `&playlist=${storeUrlArray.playlist.join(',')}`;
      }

      // Retirer les paramètres vides de l'URL générée
      storeUrlArray.url = url
        .split('&')
        .filter(param => !param.match(/=[&]?$/))
        .join('&');

      // Encoder l'URL
      storeUrlArray.urlEncoded = encodeURL(storeUrlArray.url);
      storeUrlArray.urlDecoded = decodeURL(storeUrlArray.urlEncoded);

      // Mettre à jour l'URL du navigateur
      //const baseUrl = process.env.BASE_URL+'/Refs' || 'Refs';
      //window.history.replaceState(null, '', baseUrl);
      window.history.replaceState(null, '', `?${storeUrlArray.urlDecoded}`);
    },

    addUuidToPlaylist(state, uuid) {
      if (!state.storeUrlArray.playlist.includes(uuid)) {
        state.storeUrlArray.playlist.push(uuid);
        // Met à jour l'URL après modification de la playlist
        this.commit('setStateValue', { key: 'storeUrlArray', value: state.storeUrlArray });
        // deboublonner les UUIDs dans la playlist
        this.commit('setStateValue', { key: 'storeUrlArray.playlist', value: state.storeUrlArray.playlist });
      }
    },

    removeUuidFromPlaylist(state, uuid) {
      const index = state.storeUrlArray.playlist.indexOf(uuid);
      if (index !== -1) {
        state.storeUrlArray.playlist.splice(index, 1);
        this.commit('setStateValue', { key: 'storeUrlArray', value: state.storeUrlArray });
      }
    },

    setstoreJobsDatas(state, storeJobsDatas) {
      state.storeJobsDatas = storeJobsDatas;
      
      // Utiliser getIndexIdByUuid pour mettre à jour storeUrlArray.id via uuid
      if (storeJobsDatas?.jobs && state.storeUrlArray?.uuid) {
        const job = this.getters.getIndexIdByUuid(state.storeUrlArray.uuid);
        state.storeUrlArray.id = job ? storeJobsDatas.jobs.indexOf(job) : 0;
      }
    },
    
    SET_HIDE_FICHE(state, value) {
      state.hideFiche = value;
    },
    
    TOGGLE_HIDE_FICHE(state) {
      state.hideFiche = !state.hideFiche;
    },

    ADD_TO_PLAYLIST(state, value) {
      if (!state.storeUrlArray.playlist.includes(value)) {
        state.storeUrlArray.playlist.push(value);
      }
    },
    REMOVE_FROM_PLAYLIST(state, value) {
      state.storeUrlArray.playlist = state.storeUrlArray.playlist.filter(uuid => uuid !== value);
    },
  },

  actions: {
    updateStateValue({ commit }, payload) {
      commit('setStateValue', payload);
    },

    addToPlaylist({ commit }, uuid) {
      commit('addUuidToPlaylist', uuid);
    },

    removeFromPlaylist({ commit }, uuid) {
      commit('removeUuidFromPlaylist', uuid);
    },
    
    updateStoreUrl({ state, commit }, { tag, value }) {
      commit('setStateValue', { 
        key: 'storeUrlArray', 
        value: { ...state.storeUrlArray, [tag]: value } 
      });
    },
    
    async fetchstoreJobsDatas({ commit }) {
      const paths = ['./jobs_R.json', '/jobs_R.json'];
      
      for (const path of paths) {
        try {
          const response = await axios.get(`${path}?v=${Date.now()}`);
          commit('setstoreJobsDatas', response.data);
          return;
        } catch (error) {
          console.error(`Erreur lors du chargement depuis ${path}:`, error);
        }
      }
    },
    
    setHideFiche({ commit }, value) {
      commit('SET_HIDE_FICHE', value);
    },
    
    toggleHideFiche({ commit }) {
      commit('TOGGLE_HIDE_FICHE');
    },
    
    saveActionToMemo({ state }, { action, tag, value }) {
      const params = new URLSearchParams();
      params.append('action', action);
      params.append('tag', tag);
      params.append('value', value);
      params.append('session', state.session); // <-- Utilise la valeur mémorisée
      return fetch('/Refs/memo.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params
      });
    },

    switchPlaylist({ state, commit }, value) {
      if (state.storeUrlArray.playlist.includes(value)) {
        commit('REMOVE_FROM_PLAYLIST', value);
      } else {
        commit('ADD_TO_PLAYLIST', value);
      }
    }
  },

  getters: {
    // Getters générés dynamiquement pour chaque propriété du state
    ...Object.keys(initialState).reduce((acc, key) => {
      acc[key] = state => state[key];
      return acc;
    }, {}),
    
    //getStoreUrlArray: (state) => state.storeUrlArray,
    //getstoreJobsDatas: (state) => state.storeJobsDatas,
    //getHideFiche: (state) => state.hideFiche,

    getIndexIdByUuid: (state) => (uuid) => {
      return state.storeJobsDatas?.jobs?.find((item) => item.uuid === uuid) || null;
    },
    getInfosByUuid: (state) => (uuid, langue, demande) => {
      const job = state.storeJobsDatas?.jobs?.find(j => j.uuid === uuid);
      if (!job?.[langue]) return [];

      switch (demande) {
        case 'vignette':
          return job[langue].vignette || '';
        case 'infos':
          return [job.marque, job[langue].titre];
        case 'marque':
          return job.marque || '';
        default:
          return [];
      }
    },

    urlToShare: state => {
      let url = state.storeUrlArray.url;
      if (!url) return '';
      // Remplace uuid=xxxx par uuid=rag0 (ou ajoute uuid=rag0 si absent)
      if (url.match(/uuid=[^&]*/)) {
        url = url.replace(/uuid=[^&]*/, 'uuid=rag0');
      } else {
        url += (url.includes('?') ? '&' : '?') + 'uuid=rag0';
      }
      // Si url commence déjà par http ou /Refs/, ne pas préfixer
      if (/^https?:\/\//.test(url) || url.startsWith('/Refs/')) {
        return url;
      }
      return window.location.origin + '/Refs/?' + url;
    },

  }
});